var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(" "+_vm._s(_vm.$t("Please read and agree to our terms before proceeding"))+" ")]),_c('terms-conditions',{attrs:{"targetButtonLabel":_vm.label}}),_c('b-btn',{staticClass:"mt-3",attrs:{"disabled":_vm.accepted,"variant":"primary","size":"lg","block":""},on:{"click":_vm.acceptTerms}},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }